import { render, staticRenderFns } from "./modal-user-stats.vue?vue&type=template&id=124f456e&scoped=true"
import script from "./modal-user-stats.vue?vue&type=script&lang=js"
export * from "./modal-user-stats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124f456e",
  null
  
)

export default component.exports